import { config } from "@/lib/config";

export const defaultEvents = [
  {
    title: "Lélek színei kiállítás (megnyitó)",
    start: "2024-06-28, 18 órakor",
    url: `${config.basePath}/lelek-szinei`,
    description:
      "Lélek színei kiállítás megnyitója 2024. június 28-án 18 órakor (Optika Galéria).",
  },
  {
    title: "Lélek színei kiállítás",
    start: "2024-06-28",
    end: "2024-10-01",
    url: `${config.basePath}/lelek-szinei`,
    color: "#007730",
    textColor: "white",
    editable: false,
    durationEditable: false,
    // display: 'background',
    // display: 'list-item',
    display: "block",
    allDay: true,
    description: "Lélek színei kiállítás (Optika Galéria).",
  },
  {
    title: "Csí-festés: Tengelyembe mozdulok",
    description:
      "időpontok: 2024. 2024. október 19., november 2., november 16., november 30., 2024. december 14. (16:30-20:30)",
    start: "2024-10-19 16:30",
    end: "2024-10-19 20:30",
    color: "#007730",
    // signup: `${config.basePath}/kapcsolat/csi-festes`,
    url: "https://fb.me/e/8OM7UZ3Br",
    hideOnList: false,
  },
  {
    title: "Csí-festés: Tengelyembe mozdulok",
    description: "(2. alkalom)",
    start: "2024-11-02 16:30",
    end: "2024-11-02 20:30",
    color: "#007730",
    url: "https://fb.me/e/8OM7UZ3Br",
    hideOnList: true,
  },
  {
    title: "Csí-festés: Tengelyembe mozdulok",
    description: "(3. alkalom)",
    start: "2024-11-16 16:30",
    end: "2024-11-16 20:30",
    color: "#007730",
    url: "https://fb.me/e/8OM7UZ3Br",
    hideOnList: true,
  },
  {
    title: "Csí-festés: Tengelyembe mozdulok",
    description: "(4. alkalom)",
    start: "2024-11-30 16:30",
    end: "2024-11-30 20:30",
    color: "#007730",
    url: "https://fb.me/e/8OM7UZ3Br",
    hideOnList: true,
  },
  {
    title: "Csí-festés: Tengelyembe mozdulok",
    description: "(5. alkalom)",
    start: "2024-12-14 16:30",
    end: "2024-12-14 20:30",
    color: "#007730",
    url: "https://fb.me/e/8OM7UZ3Br",
    hideOnList: true,
  },
  {
    title: "Spontán művészetterápiás alkalom",
    description: "",
    start: "2024-12-14 16:45",
    end: "2024-12-14 20:15",
    color: "#007730",
    url: "https://beart.hu/kapcsolat/spontan",
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description:
      "időpontok: 2025. március 22., április 26., május 24., június 21., július 5., augusztus 30., szeptember 20., október 11., november 22., december 13. (17:00-20:30)",
    start: "2025-03-22 17:00",
    end: "2025-03-22 20:30",
    color: "#007730",
    // signup: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: false,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(2. alkalom)",
    start: "2025-04-26 17:00",
    end: "2025-04-26 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(3. alkalom)",
    start: "2025-05-24 17:00",
    end: "2025-05-24 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(4. alkalom)",
    start: "2025-06-21 17:00",
    end: "2025-06-21 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(5. alkalom)",
    start: "2025-07-05 17:00",
    end: "2025-07-05 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(6. alkalom)",
    start: "2025-08-30 17:00",
    end: "2025-08-30 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(7. alkalom)",
    start: "2025-09-20 17:00",
    end: "2025-09-20 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(8. alkalom)",
    start: "2025-10-11 17:00",
    end: "2025-10-11 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(9. alkalom)",
    start: "2025-11-22 17:00",
    end: "2025-11-22 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: "Új művészetterápiás csoport márciustól-decemberig",
    description: "(10. alkalom)",
    start: "2025-12-13 17:00",
    end: "2025-12-13 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/uj-tavaszi-csoport`,
    hideOnList: true,
  },
  {
    title: '"Az én történetem" képregényes művészetterápiás foglalkozás',
    description:
      "Képregényes művészetterápiás foglalkozás a Lelki Forrásaink Művészetterápiás Fesztivál keretében",
    start: "2025-05-03 17:00",
    end: "2025-05-03 21:00",
    color: "#007730",
    // signup: `${config.basePath}/kapcsolat/az-en-tortenetem`,
    url: `${config.basePath}/kapcsolat/az-en-tortenetem`,
    hideOnList: false,
  },
  {
    title: "Hogy vagy most? - Télutó, tavaszváró művészetterápiás workshop",
    description:
      "Kollázs technikával nézzük meg, hol tartasz most ebben az átmenetben, a tél utolsó és a tavasz első pillanatai között. Lelki Forrásaink Művészetterápiás Fesztivál program.",
    start: "2026-02-22 18:00",
    end: "2026-02-22 21:00",
    color: "#007730",
    signup: `${config.basePath}/kapcsolat/hogy-vagy-most`,
    url: `${config.basePath}/kapcsolat/hogy-vagy-most`,
    hideOnList: false,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description:
      "időpontok: 2026. március 21., április 25., május 23., június 20., szeptember 12., október 10., november 21., december 12. (17:00-20:30, szombatonként, nyári szünettel)",
    start: "2026-03-21 17:00",
    end: "2026-03-21 20:30",
    color: "#007730",
    signup: `${config.basePath}/kapcsolat/sajat-utamon`,
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: false,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(2. alkalom)",
    start: "2026-04-25 17:00",
    end: "2026-04-25 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(3. alkalom)",
    start: "2026-05-23 17:00",
    end: "2026-05-23 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(4. alkalom)",
    start: "2026-06-20 17:00",
    end: "2026-06-20 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(5. alkalom)",
    start: "2026-09-12 17:00",
    end: "2026-09-12 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(6. alkalom)",
    start: "2026-10-10 17:00",
    end: "2026-10-10 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(7. alkalom)",
    start: "2026-11-21 17:00",
    end: "2026-11-21 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  {
    title: "Saját utamon - 8 alkalmas művészetterápiás csoport",
    description: "(8. alkalom)",
    start: "2026-12-12 17:00",
    end: "2026-12-12 20:30",
    color: "#007730",
    url: `${config.basePath}/kapcsolat/sajat-utamon`,
    hideOnList: true,
  },
  /* {
    title: "Önbizalom 5 alkalmas művészetterápiás csoport",
    description:
      "időpontok: 2024. szeptember 24., október 8., október 22., november 5., november 19. (17:30-21:00)",
    start: "2024-09-24 17:30",
    end: "2024-09-24 21:00",
    color: "#007730",
    signup: `${config.basePath}/kapcsolat/onbizalom`,
    url: "https://facebook.com/share/tViATciCTUvbtyj9",
    hideOnList: false,
  },
  {
    title: "Önbizalom 5 alkalmas művészetterápiás csoport",
    description: "(2. alkalom)",
    start: "2024-10-08 17:30",
    end: "2024-10-08 21:00",
    color: "#007730",
    //signup: `${config.basePath}/kapcsolat`,
    url: "https://facebook.com/share/tViATciCTUvbtyj9",
    hideOnList: true,
  },
  {
    title: "Önbizalom 5 alkalmas művészetterápiás csoport",
    description: "(3. alkalom)",
    start: "2024-10-22 17:30",
    end: "2024-10-22 21:00",
    color: "#007730",
    //signup: `${config.basePath}/kapcsolat`,
    url: "https://facebook.com/share/tViATciCTUvbtyj9",
    hideOnList: true,
  },
  {
    title: "Önbizalom 5 alkalmas művészetterápiás csoport",
    description: "(4. alkalom)",
    start: "2024-11-05 17:30",
    end: "2024-11-05 21:00",
    color: "#007730",
    //signup: `${config.basePath}/kapcsolat`,
    url: "https://facebook.com/share/tViATciCTUvbtyj9",
    hideOnList: true,
  },
  {
    title: "Önbizalom 5 alkalmas művészetterápiás csoport",
    description: "(5. alkalom)",
    start: "2024-11-19 17:30",
    end: "2024-11-19 21:00",
    color: "#007730",
    //signup: `${config.basePath}/kapcsolat`,
    url: "https://facebook.com/share/tViATciCTUvbtyj9",
    hideOnList: true,
  },
  /* { title: 'All Day Event', start: '2024-07-01' },
         { title: 'Long Event', start: '2024-07-07', end: '2024-07-10' },
         { groupId: '999', title: 'Repeating Event', start: '2024-07-09T16:00:00' },
         { groupId: '999', title: 'Repeating Event', start: '2024-07-16T16:00:00' },
         { title: 'Conference', start: '2024-07-11', end: '2024-07-13' },
         { title: 'Click for Google', url: 'http://google.com/', start: '2024-07-28' }*/
];

export const cleanEventLink = (url: string) => {
  return url.replace(/\s/, "_").replace(/:/, "-");
};
